import { RoutesEnum } from '../enums/routes.enum';

/**
 * Inicializaión de la clase PhotosModel
 *
 * *Set PhotosModel clase*
 *
 * @access public
 * @type {class}
 */
export class PhotosModel {

  /**
   * Documento de certificación del usuario (selección del usuario)
   *
   * *User's work certification (user's selection)*
   *
   * @var {boolean} isWorkCertificateSelected
   */
  isWorkCertificateSelected: boolean;
  /**
   * Documento de IVA (selección del usuario)
   *
   * User's IVA Document (user's selection)
   *
   * @var {boolean} isIVAPdfSelected
   */
  isIVAPdfSelected: boolean;
  /**
   * Documento de IVA Primera Página (selección del usuario)
   *
   * User's fisrt page IVA Document (user's selection)
   *
   * @var {boolean} isIVAFirstPageSelected
   */
  isIVAFirstPageSelected: boolean;
  /**
   * Documento de IVA segunda página (selección del usuario)
   *
   * *User's second page IVA Document (user's selection)*
   *
   * @var {boolean} isIVASecondPageSelected
   */
  isIVASecondPageSelected: boolean;
  /**
   * Documento IPS (selección del usuario)
   * *User's IPS document (user's selection)*
   *
   * @var {boolean} isIPSSelected
   */
  isIPSSelected: boolean;
  /**
   * Comprobante de ingresos del usuario
   *
   * *User's incomes certification (user's selection)*
   *
   * @var {boolean} isCompIngressoSelected
   */
  isCompIngressoSelected: boolean;

  /**
   * Rutas de navegación
   *
   * *Navigation routes*
   *
   * @var {RoutesEnum[]} routes
   */
  routes: RoutesEnum[];

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * @var {boolean} isWorkCertificateSelected Sets variable as false
   * @var {boolean} isIPSSelected  Sets variable as false
   * @var {boolean} isIVAPdfSelected  Sets variable as false
   * @var {boolean} isIVAFirstPageSelected  Sets variable as false
   * @var {boolean} isIVASecondPageSelected  Sets variable as false
   * @var {boolean} isCompIngressoSelected  Sets variable as false
   * @var {Array} routes  Sets as new Array
   *
   */
  constructor() {
    this.isWorkCertificateSelected = false;
    this.isIPSSelected = false;
    this.isIVAPdfSelected = false;
    this.isIVAFirstPageSelected = false;
    this.isIVASecondPageSelected = false;
    this.isCompIngressoSelected = false;
    this.routes = new Array();
  }
}
